var map = {
	"./1.jpg": 144,
	"./10.jpg": 145,
	"./11.jpg": 146,
	"./12.jpg": 147,
	"./13.jpg": 148,
	"./14.jpg": 149,
	"./2.jpg": 150,
	"./3.jpg": 151,
	"./4.jpg": 152,
	"./5.jpg": 153,
	"./6.jpg": 154,
	"./7.jpg": 155,
	"./8.jpg": 156,
	"./9.jpg": 157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 143;